import { render, staticRenderFns } from "./EditShopAddressDialog.vue?vue&type=template&id=4949888c&scoped=true&lang=pug&"
import script from "./EditShopAddressDialog.vue?vue&type=script&lang=ts&"
export * from "./EditShopAddressDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditShopAddressDialog.vue?vue&type=style&index=0&id=4949888c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4949888c",
  null
  
)

export default component.exports